import { render, staticRenderFns } from "./one-drive-file-access-action-input.vue?vue&type=template&id=6b5053a3&scoped=true"
import script from "./one-drive-file-access-action-input.vue?vue&type=script&lang=js"
export * from "./one-drive-file-access-action-input.vue?vue&type=script&lang=js"
import style0 from "./one-drive-file-access-action-input.vue?vue&type=style&index=0&id=6b5053a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5053a3",
  null
  
)

export default component.exports